import { Team } from '../../../../../types/sport';

export const PREMIER_LEAGUE_TEAMS: Team[] = [
  {
    value: 'liverpool',
    label: 'Liverpool',
    players: [
      { value: 'alexis mac allister', label: 'Alexis Mac Allister', country: 'argentina' },
      { value: 'alisson becker', label: 'Alisson Becker', country: 'brasil' },
      { value: 'florian wirtz', label: 'Florian Wirtz', country: 'alemania' },
      { value: 'virgil van dijk', label: 'Virgil Van Dijk', country: 'paises_bajos' }
    ]
  },
  {
    value: 'manchester city',
    label: 'Manchester City',
    players: [
      { value: 'erling haaland', label: 'Erling Haaland', country: 'noruega' },
      { value: 'kevin de bruyne', label: 'Kevin De Bruyne', country: 'belgica' },
      { value: 'phil foden', label: 'Phil Foden', country: 'inglaterra' },
      { value: 'rodri', label: 'Rodri', country: 'espana' }
    ]
  },
  {
    value: 'manchester united',
    label: 'Manchester United',
    players: [
      { value: 'bruno fernandes', label: 'Bruno Fernandes', country: 'portugal' },
      { value: 'casemiro', label: 'Casemiro', country: 'brasil' },
      { value: 'diogo dalot', label: 'Diogo Dalot', country: 'portugal' },
      { value: 'lisandro martinez', label: 'Lisandro Martínez', country: 'argentina' }
    ]
  }
];
